module.exports = __webpack_public_path__ + "img/29_55.8e817ea6.png";